<template>
  <div class="DateOfCommissioning">
    <FieldSet
      :label="label"
      :values="values"
      :fields="fields"
      :validation="validation"
      :layout="layout"
      :disabled="disabled"
      :path="path"
    />
  </div>
</template>

<script>
import FieldSet from '@/components/form/FieldSet'
import { DateOfCommissioningFields } from '@/config'

export default {
  name: 'DateOfCommissioning',
  components: { FieldSet },
  props: {
    label: {
      type: String,
      default: '',
    },
    values: {
      type: Object,
      default: function() {
        return {}
      },
    },
    path: {
      type: String,
      default: 'DateOfCommissioning',
    },
    disabled: {
      type: Boolean,
      default: false,
    },
  },
  data() {
    return {
      fields: DateOfCommissioningFields,
      layout: [{
        'columns': '1fr 1fr',
        'fields': ['DateOfCommissioning', 'DateOfEnergyConnection', 'EAN'],
      }],
      validation: {},
    }
  },
}
</script>
